import React from 'react';
import { cn } from '../../lib/utils';
interface BookCallButtonProps {
  onClick: () => void;
  className?: string;
}
export const BookCallButton: React.FC<BookCallButtonProps> = ({
  onClick,
  className
}) => {
  return <button onClick={onClick} className={cn('py-3 px-8 text-white font-medium rounded-lg text-base sm:text-lg', 'bg-gradient-to-r from-[#00AEEF]/90 to-[#00AEEF] hover:from-[#00AEEF] hover:to-[#00AEEF]', 'transition-all duration-300 transform hover:scale-105 shadow-lg', className)} data-id="element-81">
      Apply Now
    </button>;
};